/**
 * RESPONSIBILITY: the home page's events strip.
 *
 * The events come from the one events list; this band owns only the words around them.
 */
import type { HomeEventsSection, EventRow } from '@app/sections';
import { EventCarousel } from '../events/EventCarousel';

export function HomeEvents({ c, events }: { c: HomeEventsSection; events: EventRow[] }) {
  return (
    <section className="band band-tint">
      <div className="wrap">
        <div className="band-head">
          <div>
            {c.eyebrow && <span className="band-kicker">{c.eyebrow}</span>}
            <h2>{c.heading}</h2>
          </div>
          {c.linkLabel && <a className="btn btn-ghost" href={c.linkHref || '#events'}>{c.linkLabel}</a>}
        </div>
        <EventCarousel
          events={events}
          seconds={c.autoSeconds}
          resumeAfter={c.resumeSeconds}
          prevLabel={c.prevLabel}
          nextLabel={c.nextLabel}
          pauseLabel={c.pauseLabel}
          playLabel={c.playLabel}
        />
      </div>
    </section>
  );
}
